import { render, staticRenderFns } from "./AppSidebarNav.vue?vue&type=template&id=341d40aa&"
import script from "./AppSidebarNav.vue?vue&type=script&lang=js&"
export * from "./AppSidebarNav.vue?vue&type=script&lang=js&"
import style0 from "./AppSidebarNav.vue?vue&type=style&index=0&id=341d40aa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports